import * as Yup from "yup";

const UserSchema = {};

UserSchema.validateUserAdd = (isAccessCodeRequired) => {
  return Yup.object({
    user_name: Yup.string()
      .required("User name is required.")
      .min(3, "User name minimum length is 3")
      .max(45, "User name should be at most 45 characters.")
      // .matches(/^[aA-zZ-\s]+$/, `User name should be alphabetic only`)
      .matches(/^[a-zA-Z0-9\s-]+$/, "User name should be alphanumeric only"),
    user_mob: Yup.string()
      .required("User mobile is required.")
      .min(9, "User contact Length must be 9 to 13 Digits")
      .max(13, "User contact Length must be 9 to 13 Digits"),
    role_id: Yup.string().required("User Role is required."),
    pin: Yup.string()
      .required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(4, "User pin must be exactly 4 digits")
      .max(4, "User pin must be exactly 4 digits"),
    comp_id: Yup.string().when("role_id", (role_id, schema) => {
      if (role_id == 2) return schema.required("Company is required");
      return schema;
    }),
    branch_id: Yup.string().when("role_id", (role_id, schema) => {
      if (role_id == 3 || role_id == 4 || role_id == 5)
        return schema.required("Branch is required");
      return schema;
    }),
    godown_id: Yup.string().when("role_id", (role_id, schema) => {
      if (role_id == 5) return schema.required("Godown is required");
      return schema;
    }),
    back_date: Yup.string().required("Back Days is required."),
    access_code: isAccessCodeRequired
      ? Yup.string()
          .required("Access code is required.")
          .length(4, "Access code must be exactly 4 digits.")
      : Yup.string().nullable(),
  });
};

UserSchema.validateUserEdit = (isAccessCodeRequired) => {
  return Yup.object({
    user_name: Yup.string()
      .required("User name is required.")
      .min(3, "User name minimum length is 3")
      .max(45, "User name should be at most 100 characters.")
      // .matches(/^[aA-zZ-\s]+$/, `User name should be alphabetic only`),
      .matches(/^[a-zA-Z0-9\s-]+$/, "User name should be alphanumeric only"),
    user_mob: Yup.string()
      .required("User mobile is required.")
      .min(9, "User contact Length must be 9 to 13 Digits")
      .max(13, "User contact Length must be 9 to 13 Digits"),
    item_level_narration: Yup.string().when("role_id", {
      is: "2", // props.id.role_id == 2 wala case
      then: (schema) => schema.required("Item Narration is required."),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

    pin: Yup.string()
      .required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(4, "User pin must be exactly 4 digits")
      .max(4, "User pin must be exactly 4 digits"),
    role_id: Yup.string().required("User Role is required."),
    comp_id: Yup.string().when("role_id", (role_id, schema) => {
      if (role_id == 2) return schema.required("Company is required");
      return schema;
    }),
    branch_id: Yup.string().when("role_id", (role_id, schema) => {
      if (role_id == 3 || role_id == 4 || role_id == 5)
        return schema.required("Branch is required");
      return schema;
    }),
    godown_id: Yup.string().when("role_id", (role_id, schema) => {
      if (role_id == 5) return schema.required("Godown is required");
      return schema;
    }),
    back_date: Yup.string().required("Back Days is required."),
    access_code: isAccessCodeRequired
      ? Yup.string()
          .required("Access code is required.")
          .length(4, "Access code must be exactly 4 digits.")
      : Yup.string().nullable(),
  });
};

export default UserSchema;
